export enum StackTypeCode {
  HOME_STACK = "HOME_STACK",
  POST_STACK = "POST_STACK",
  MALLMAIN_STACK = "MALLMAIN_STACK",
  BRANDCOMMUNITYMAIN_STACK = "BRANDCOMMUNITYMAIN_STACK",
  QNA_STACK = "QNA_STACK",
  MISSION_STACK = "MISSION_STACK",
}
